import { render } from "./TemplateManagerModal.vue?vue&type=template&id=1cf110dd&scoped=true"
import script from "./TemplateManagerModal.vue?vue&type=script&lang=js"
export * from "./TemplateManagerModal.vue?vue&type=script&lang=js"

import "./TemplateManagerModal.vue?vue&type=style&index=0&id=1cf110dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf110dd"]])

export default __exports__